/**
 * Dates from the API come in two shapes:
 * - calendar dates 'YYYY-MM-DD' (issue date, due date): shown as-is, never shifted by time zones;
 * - timestamps (ISO 8601): shown in Egypt's business time zone, like the server's issue date.
 */
export const BUSINESS_TIME_ZONE = 'Africa/Cairo';

const cache = new Map<string, Intl.DateTimeFormat>();
function dateFormatter(locale: string, options: Intl.DateTimeFormatOptions): Intl.DateTimeFormat {
  const key = `${locale}|${JSON.stringify(options)}`;
  let cached = cache.get(key);
  if (!cached) {
    cached = new Intl.DateTimeFormat(locale, options);
    cache.set(key, cached);
  }
  return cached;
}

const CALENDAR_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatCalendarDate(value: string, locale: string): string {
  const match = CALENDAR_DATE.exec(value);
  if (!match) return value;
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  return dateFormatter(locale, { dateStyle: 'medium', timeZone: 'UTC' }).format(date);
}

export function formatTimestamp(value: string, locale: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return dateFormatter(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: BUSINESS_TIME_ZONE,
  }).format(date);
}

/** Today's calendar date in the business time zone, as 'YYYY-MM-DD'. */
export function todayInBusinessZone(now: Date = new Date()): string {
  return dateFormatter('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: BUSINESS_TIME_ZONE,
  }).format(now);
}
